import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import ordinal from 'ordinal';
import { GameGuideHelpButton } from '../../components/gameGuideHelpButton';
import { SELF_PANEL_BACKGROUND_COLOR } from '../../styles/colors';
import { ALL_MEDAL_PROPERTIES } from '../../types/medalProperties';
import { PANEL_ITEM_PADDING_CSS } from '../panelItem';
import { MEDAL_SIZES, MedalImageDisplay } from './medalImageDisplay';
import { MedalPanelRankingsButton } from './medalPanelRankingsButton';
const CONTAINER_CSS = css(PANEL_ITEM_PADDING_CSS, css `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 2px 10px;
  `);
const MEDAL_SIZE_PX = MEDAL_SIZES.large;
const NON_IMAGE_CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${MEDAL_SIZE_PX}px;
  min-width: ${MEDAL_SIZE_PX}px;
  height: ${MEDAL_SIZE_PX}px;
  min-height: ${MEDAL_SIZE_PX}px;
  color: ${SELF_PANEL_BACKGROUND_COLOR};
`;
const INFO_LIST_CSS = css `
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  ul {
    margin: 0;
    padding: 0 0 0 20px;
  }
`;
function getBulletedItems(rank, infoItems) {
    const bulletedItems = [];
    if (rank) {
        bulletedItems.push(`${ordinal(rank)} Place`);
    }
    bulletedItems.push(...infoItems);
    return bulletedItems;
}
export const MedalPanelItem = ({ medal }) => {
    const { type, rank } = medal;
    const imageUrl = ALL_MEDAL_PROPERTIES[type].getImageUrl?.(medal);
    const { name, infoItemsCreator, gameGuideDetailPageType, rankingType } = ALL_MEDAL_PROPERTIES[type];
    const infoItems = infoItemsCreator ? infoItemsCreator(medal) : [];
    const bulletedItems = getBulletedItems(rank, infoItems);
    return (_jsxs("section", { css: CONTAINER_CSS, "aria-label": `${name} Medal`, children: [imageUrl ? (_jsx(MedalImageDisplay, { medalName: name, imageUrl: imageUrl })) : (_jsx("div", { css: NON_IMAGE_CONTAINER_CSS, "aria-label": `${name} Medal Image Placeholder`, "aria-hidden": true, children: _jsx(StarRoundedIcon, {}) })), _jsxs("div", { css: INFO_LIST_CSS, children: [_jsx("div", { "aria-hidden": true, children: name }), bulletedItems.length > 0 && (_jsx("ul", { children: bulletedItems.map((bulletedItem, i) => (_jsx("li", { children: bulletedItem }, i))) })), rankingType && (_jsx("div", { children: _jsx(MedalPanelRankingsButton, { rankingType: rankingType }) }))] }), gameGuideDetailPageType && _jsx(GameGuideHelpButton, { pageType: gameGuideDetailPageType, title: 'More Info' })] }));
};
